// <auto-generated/>
// Contents of: hl7.fhir.r4.core version: 4.0.1
  // Primitive Naming Style: None
  // Complex Type / Resource Naming Style: PascalCase
  // Interaction Naming Style: None
  // Extension Support: NonPrimitive
  // Restricted to: Patient|Encounter|Questionnaire|QuestionnaireResponse|Observation|GuidanceResponse|CarePlan|ServiceRequest|Parameters|OperationOutcome
  // Language option: "namespaceRoot" = "IntgelligentNav.Fhir"
  // Language option: "partialClasses" = "true"
  // Language option: "systemTextJson" = "true"
  // Language option: "tolerantEnums" = "true"
  // Language option: "singleFile" = "false"
// Minimum TypeScript Version: 3.7
import * as fhir from '../fhir'
/**
 * A set of rules that describe when the event is scheduled.
 */
export type ITimingRepeat = fhir.IFhirElement & {
  /**
   * Either a duration for the length of the timing schedule, a range of possible length, or outer bounds for start and/or end limits of the timing schedule.
   */
  boundsDuration?: fhir.IDuration|undefined;
  /**
   * Either a duration for the length of the timing schedule, a range of possible length, or outer bounds for start and/or end limits of the timing schedule.
   */
  boundsRange?: fhir.IRange|undefined;
  /**
   * Either a duration for the length of the timing schedule, a range of possible length, or outer bounds for start and/or end limits of the timing schedule.
   */
  boundsPeriod?: fhir.IPeriod|undefined;
  /**
   * If you have both bounds and count, then this should be understood as within the bounds period, until count times happens.
   */
  count?: number|undefined;
  _count?: fhir.IFhirElement|undefined;
  /**
   * If present, indicates that the count is a range - so to perform the action between [count] and [countMax] times.
   */
  countMax?: number|undefined;
  _countMax?: fhir.IFhirElement|undefined;
  /**
   * If no days are specified, the action is assumed to happen every day as otherwise specified. The elements frequency and period cannot be used as well as dayOfWeek.
   */
  dayOfWeek?: TimingRepeatDayOfWeekEnum[]|undefined;
  _dayOfWeek?: fhir.IFhirElement[]|undefined;
  /**
   * For some events the duration is part of the definition of the event (e.g. IV infusions, where the duration is implicit in the specified quantity and rate). For others, it's part of the timing specification (e.g. exercise).
   */
  duration?: number|undefined;
  _duration?: fhir.IFhirElement|undefined;
  /**
   * For some events the duration is part of the definition of the event (e.g. IV infusions, where the duration is implicit in the specified quantity and rate). For others, it's part of the timing specification (e.g. exercise).
   */
  durationMax?: number|undefined;
  _durationMax?: fhir.IFhirElement|undefined;
  /**
   * The units of time for the duration, in UCUM units.
   */
  durationUnit?: TimingRepeatDurationUnitEnum|undefined;
  _durationUnit?: fhir.IFhirElement|undefined;
  /**
   * The number of times to repeat the action within the specified period. If frequencyMax is present, this element indicates the lower bound of the allowed range of the frequency.
   */
  frequency?: number|undefined;
  _frequency?: fhir.IFhirElement|undefined;
  /**
   * If present, indicates that the frequency is a range - so to repeat between [frequency] and [frequencyMax] times within the period or period range.
   */
  frequencyMax?: number|undefined;
  _frequencyMax?: fhir.IFhirElement|undefined;
  /**
   * The number of minutes from the event. If the event code does not indicate whether the minutes is before or after the event, then the offset is assumed to be after the event.
   */
  offset?: number|undefined;
  _offset?: fhir.IFhirElement|undefined;
  /**
   * Indicates the duration of time over which repetitions are to occur; e.g. to express "3 times per day", 3 would be the frequency and "1 day" would be the period. If periodMax is present, this element indicates the lower bound of the allowed range of the period length.
   */
  period?: number|undefined;
  _period?: fhir.IFhirElement|undefined;
  /**
   * If present, indicates that the period is a range from [period] to [periodMax], allowing expressing concepts such as "do this once every 3-5 days.
   */
  periodMax?: number|undefined;
  _periodMax?: fhir.IFhirElement|undefined;
  /**
   * The units of time for the period in UCUM units.
   */
  periodUnit?: TimingRepeatPeriodUnitEnum|undefined;
  _periodUnit?: fhir.IFhirElement|undefined;
  /**
   * When time of day is specified, it is inferred that the action happens every day (as filtered by dayofWeek) on the specified times. The elements when, frequency and period cannot be used as well as timeOfDay.
   */
  timeOfDay?: string[]|undefined;
  _timeOfDay?: fhir.IFhirElement[]|undefined;
  /**
   * When more than one event is listed, the event is tied to the union of the specified events.
   */
  when?: string[]|undefined;
  _when?: fhir.IFhirElement[]|undefined;
}
/**
 * Specifies an event that may occur multiple times. Timing schedules are used to record when things are planned, expected or requested to occur. The most common usage is in dosage instructions for medications. They are also used when planning care of various kinds, and may be used for reporting the schedule to which past regular activities were carried out.
 */
export type ITiming = fhir.IBackboneElement & {
  /**
   * BID etc. are defined as 'at institutionally specified times'. For example, an institution may choose that BID is "always at 7am and 6pm".  If it is inappropriate for this choice to be made, the code BID should not be used. Instead, a distinct organization-specific code should be used in place of the HL7-defined BID code and/or a structured representation should be used (in this case, specifying the two event times).
   */
  code?: fhir.ICodeableConcept|undefined;
  /**
   * Identifies specific times when the event occurs.
   */
  event?: string[]|undefined;
  _event?: fhir.IFhirElement[]|undefined;
  /**
   * A set of rules that describe when the event is scheduled.
   */
  repeat?: fhir.ITimingRepeat|undefined;
}
/**
 * A set of rules that describe when the event is scheduled.
 */
export class TimingRepeat extends fhir.FhirElement implements fhir.ITimingRepeat {
  /**
   * Either a duration for the length of the timing schedule, a range of possible length, or outer bounds for start and/or end limits of the timing schedule.
   */
  public boundsDuration?: fhir.Duration|undefined;
  /**
   * Either a duration for the length of the timing schedule, a range of possible length, or outer bounds for start and/or end limits of the timing schedule.
   */
  public boundsRange?: fhir.Range|undefined;
  /**
   * Either a duration for the length of the timing schedule, a range of possible length, or outer bounds for start and/or end limits of the timing schedule.
   */
  public boundsPeriod?: fhir.Period|undefined;
  /**
   * If you have both bounds and count, then this should be understood as within the bounds period, until count times happens.
   */
  public count?: number|undefined;
  public _count?: fhir.FhirElement|undefined;
  /**
   * If present, indicates that the count is a range - so to perform the action between [count] and [countMax] times.
   */
  public countMax?: number|undefined;
  public _countMax?: fhir.FhirElement|undefined;
  /**
   * If no days are specified, the action is assumed to happen every day as otherwise specified. The elements frequency and period cannot be used as well as dayOfWeek.
   */
  public dayOfWeek?: TimingRepeatDayOfWeekEnum[]|undefined;
  public _dayOfWeek?: fhir.FhirElement[]|undefined;
  /**
   * For some events the duration is part of the definition of the event (e.g. IV infusions, where the duration is implicit in the specified quantity and rate). For others, it's part of the timing specification (e.g. exercise).
   */
  public duration?: number|undefined;
  public _duration?: fhir.FhirElement|undefined;
  /**
   * For some events the duration is part of the definition of the event (e.g. IV infusions, where the duration is implicit in the specified quantity and rate). For others, it's part of the timing specification (e.g. exercise).
   */
  public durationMax?: number|undefined;
  public _durationMax?: fhir.FhirElement|undefined;
  /**
   * The units of time for the duration, in UCUM units.
   */
  public durationUnit?: TimingRepeatDurationUnitEnum|undefined;
  public _durationUnit?: fhir.FhirElement|undefined;
  /**
   * The number of times to repeat the action within the specified period. If frequencyMax is present, this element indicates the lower bound of the allowed range of the frequency.
   */
  public frequency?: number|undefined;
  public _frequency?: fhir.FhirElement|undefined;
  /**
   * If present, indicates that the frequency is a range - so to repeat between [frequency] and [frequencyMax] times within the period or period range.
   */
  public frequencyMax?: number|undefined;
  public _frequencyMax?: fhir.FhirElement|undefined;
  /**
   * The number of minutes from the event. If the event code does not indicate whether the minutes is before or after the event, then the offset is assumed to be after the event.
   */
  public offset?: number|undefined;
  public _offset?: fhir.FhirElement|undefined;
  /**
   * Indicates the duration of time over which repetitions are to occur; e.g. to express "3 times per day", 3 would be the frequency and "1 day" would be the period. If periodMax is present, this element indicates the lower bound of the allowed range of the period length.
   */
  public period?: number|undefined;
  public _period?: fhir.FhirElement|undefined;
  /**
   * If present, indicates that the period is a range from [period] to [periodMax], allowing expressing concepts such as "do this once every 3-5 days.
   */
  public periodMax?: number|undefined;
  public _periodMax?: fhir.FhirElement|undefined;
  /**
   * The units of time for the period in UCUM units.
   */
  public periodUnit?: TimingRepeatPeriodUnitEnum|undefined;
  public _periodUnit?: fhir.FhirElement|undefined;
  /**
   * When time of day is specified, it is inferred that the action happens every day (as filtered by dayofWeek) on the specified times. The elements when, frequency and period cannot be used as well as timeOfDay.
   */
  public timeOfDay?: string[]|undefined;
  public _timeOfDay?: fhir.FhirElement[]|undefined;
  /**
   * When more than one event is listed, the event is tied to the union of the specified events.
   */
  public when?: string[]|undefined;
  public _when?: fhir.FhirElement[]|undefined;
  /**
   * Default constructor for TimingRepeat - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.ITimingRepeat> = {}) {
    super(source);
    if (source["boundsDuration"]) { this.boundsDuration = new fhir.Duration(source.boundsDuration!); }
    if (source["boundsRange"]) { this.boundsRange = new fhir.Range(source.boundsRange!); }
    if (source["boundsPeriod"]) { this.boundsPeriod = new fhir.Period(source.boundsPeriod!); }
    if (source["count"]) { this.count = source.count; }
    if (source["_count"]) { this._count = new fhir.FhirElement(source._count!); }
    if (source["countMax"]) { this.countMax = source.countMax; }
    if (source["_countMax"]) { this._countMax = new fhir.FhirElement(source._countMax!); }
    if (source["dayOfWeek"]) { this.dayOfWeek = source.dayOfWeek.map((x) => (x)); }
    if (source["_dayOfWeek"]) { this._dayOfWeek = source._dayOfWeek.map((x:Partial<fhir.IFhirElement>) => new fhir.FhirElement(x)); }
    if (source["duration"]) { this.duration = source.duration; }
    if (source["_duration"]) { this._duration = new fhir.FhirElement(source._duration!); }
    if (source["durationMax"]) { this.durationMax = source.durationMax; }
    if (source["_durationMax"]) { this._durationMax = new fhir.FhirElement(source._durationMax!); }
    if (source["durationUnit"]) { this.durationUnit = source.durationUnit; }
    if (source["_durationUnit"]) { this._durationUnit = new fhir.FhirElement(source._durationUnit!); }
    if (source["frequency"]) { this.frequency = source.frequency; }
    if (source["_frequency"]) { this._frequency = new fhir.FhirElement(source._frequency!); }
    if (source["frequencyMax"]) { this.frequencyMax = source.frequencyMax; }
    if (source["_frequencyMax"]) { this._frequencyMax = new fhir.FhirElement(source._frequencyMax!); }
    if (source["offset"]) { this.offset = source.offset; }
    if (source["_offset"]) { this._offset = new fhir.FhirElement(source._offset!); }
    if (source["period"]) { this.period = source.period; }
    if (source["_period"]) { this._period = new fhir.FhirElement(source._period!); }
    if (source["periodMax"]) { this.periodMax = source.periodMax; }
    if (source["_periodMax"]) { this._periodMax = new fhir.FhirElement(source._periodMax!); }
    if (source["periodUnit"]) { this.periodUnit = source.periodUnit; }
    if (source["_periodUnit"]) { this._periodUnit = new fhir.FhirElement(source._periodUnit!); }
    if (source["timeOfDay"]) { this.timeOfDay = source.timeOfDay.map((x) => (x)); }
    if (source["_timeOfDay"]) { this._timeOfDay = source._timeOfDay.map((x:Partial<fhir.IFhirElement>) => new fhir.FhirElement(x)); }
    if (source["when"]) { this.when = source.when.map((x) => (x)); }
    if (source["_when"]) { this._when = source._when.map((x:Partial<fhir.IFhirElement>) => new fhir.FhirElement(x)); }
  }
  /**
   * Check if the current TimingRepeat contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a TimingRepeat from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.ITimingRepeat):TimingRepeat {
    var dest:TimingRepeat = new TimingRepeat(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `TimingRepeat is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
/**
 * Specifies an event that may occur multiple times. Timing schedules are used to record when things are planned, expected or requested to occur. The most common usage is in dosage instructions for medications. They are also used when planning care of various kinds, and may be used for reporting the schedule to which past regular activities were carried out.
 */
export class Timing extends fhir.BackboneElement implements fhir.ITiming {
  /**
   * BID etc. are defined as 'at institutionally specified times'. For example, an institution may choose that BID is "always at 7am and 6pm".  If it is inappropriate for this choice to be made, the code BID should not be used. Instead, a distinct organization-specific code should be used in place of the HL7-defined BID code and/or a structured representation should be used (in this case, specifying the two event times).
   */
  public code?: fhir.CodeableConcept|undefined;
  /**
   * Identifies specific times when the event occurs.
   */
  public event?: string[]|undefined;
  public _event?: fhir.FhirElement[]|undefined;
  /**
   * A set of rules that describe when the event is scheduled.
   */
  public repeat?: fhir.TimingRepeat|undefined;
  /**
   * Default constructor for Timing - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.ITiming> = {}) {
    super(source);
    if (source["code"]) { this.code = new fhir.CodeableConcept(source.code!); }
    if (source["event"]) { this.event = source.event.map((x) => (x)); }
    if (source["_event"]) { this._event = source._event.map((x:Partial<fhir.IFhirElement>) => new fhir.FhirElement(x)); }
    if (source["repeat"]) { this.repeat = new fhir.TimingRepeat(source.repeat!); }
  }
  /**
   * Check if the current Timing contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a Timing from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.ITiming):Timing {
    var dest:Timing = new Timing(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `Timing is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
/**
 * Code Values for the Timing.repeat.dayOfWeek field
 */
export enum TimingRepeatDayOfWeekEnum {
  MON = "mon",
  TUE = "tue",
  WED = "wed",
  THU = "thu",
  FRI = "fri",
  SAT = "sat",
  SUN = "sun",
}
/**
 * Code Values for the Timing.repeat.durationUnit field
 */
export enum TimingRepeatDurationUnitEnum {
  S = "s",
  MIN = "min",
  H = "h",
  D = "d",
  WK = "wk",
  MO = "mo",
  A = "a",
}
/**
 * Code Values for the Timing.repeat.periodUnit field
 */
export enum TimingRepeatPeriodUnitEnum {
  S = "s",
  MIN = "min",
  H = "h",
  D = "d",
  WK = "wk",
  MO = "mo",
  A = "a",
}
